import PropTypes from "prop-types";
import { isMembersSpace } from "@/react/helpers/spaceHelpers";
import { SpaceHeaderNoDropdown } from "./SpaceHeaderNoDropdown";
import { SpaceHeaderTitleFullScreen } from "./SpaceHeaderTitleFullScreen";

export const SpaceHeaderTitle = ({ space, hasDropdown = true }) => {
  const shouldShowMembersCount =
    isMembersSpace(space) && !space.hide_members_count;

  if (!hasDropdown) {
    return (
      <SpaceHeaderNoDropdown
        space={space}
        shouldShowMembersCount={shouldShowMembersCount}
      />
    );
  }

  return (
    <SpaceHeaderTitleFullScreen
      space={space}
      shouldShowMembersCount={shouldShowMembersCount}
    />
  );
};

SpaceHeaderTitle.propTypes = {
  space: PropTypes.shape({
    emoji: PropTypes.string,
    is_private: PropTypes.bool,
    name: PropTypes.string,
    hide_members_count: PropTypes.bool,
  }).isRequired,
  hasDropdown: PropTypes.bool,
};
